/**
 * Server-Sent Events helper for the assistant chat streaming endpoint.
 * Native EventSource does not allow POST + Authorization headers, so we use fetch + ReadableStream.
 */
export async function streamAssistantChat({ token, baseUrl, body, onDelta, onSession, onDone, onError, signal }) {
  const url = `${baseUrl.replace(/\/$/, "")}/api/assistant/chat/stream`;
  let sessionId = null;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "text/event-stream",
      },
      body: JSON.stringify(body),
      signal,
    });
    if (!res.ok || !res.body) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `HTTP ${res.status}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buf = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      // SSE events are separated by \n\n
      let idx;
      while ((idx = buf.indexOf("\n\n")) !== -1) {
        const chunk = buf.slice(0, idx);
        buf = buf.slice(idx + 2);
        const lines = chunk.split("\n");
        let event = "message";
        let dataRaw = "";
        for (const line of lines) {
          if (line.startsWith("event:")) event = line.slice(6).trim();
          else if (line.startsWith("data:")) dataRaw += line.slice(5).trim();
        }
        if (!dataRaw) continue;
        let data;
        try { data = JSON.parse(dataRaw); } catch { continue; }
        if (event === "session") { sessionId = data.session_id; onSession?.(sessionId); }
        else if (event === "delta") { onDelta?.(data.t || ""); }
        else if (event === "done") { onDone?.(data); return sessionId; }
        else if (event === "error") { throw new Error(data.message || "Erreur stream"); }
      }
    }
    onDone?.({ session_id: sessionId });
    return sessionId;
  } catch (err) {
    if (err.name !== "AbortError") onError?.(err);
    throw err;
  }
}
